export default "__VITE_ASSET__Bg$6dhgt__"